// extracted by mini-css-extract-plugin
module.exports = {"scrollbox":"pinned-notes_scrollbox__SLQEz","pinnedNotesHeading":"pinned-notes_pinnedNotesHeading__9hyNC","container":"pinned-notes_container__t78i5"};